export default __webpack_public_path__ + "static/char-s-29-en-697f05bfe866d544d24ad64445d95729.webp";